import React from 'react';
import { StackedBarChart } from '@carbon/charts-react';
import '@carbon/charts-react/styles.css';

const hideMoreOptionsStyle = `
  .cds--cc--toolbar button[aria-label="More options"],
  .bx--cc--toolbar button[aria-label="More options"],
  .cds--overflow-menu__trigger[aria-label="More options"] {
    display: none !important;
  }

  .cds--cc--toolbar button,
  .bx--cc--toolbar button {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  .cds--cc--toolbar button:hover,
  .bx--cc--toolbar button:hover {
    color: #08BDBA !important;
    fill: #08BDBA !important;
  }
`;

const StackedBar = ({ data, title }) => {
  const options = {
    title,
    theme: 'g100',
    axes: {
      left: {
        mapsTo: 'value',
        title: 'Camiones',
        stacked: true,             // ✅ REQUIRED for stacking!
        ticks: {
          formatter: (e) =>
            typeof e === 'number' ? e?.toLocaleString?.('es-CL') : e.toString(),
        },
      },
      bottom: {
        mapsTo: 'key',             // ✅ categorical field
        scaleType: 'labels',       // ✅ categorical x-axis
        title: 'Hora',
      },
    },
    color: {
      pairing: { numberOfVariants: 8 },
    },
    height: '320px',
    legend: { enabled: true, alignment: 'center' },
    toolbar: { enabled: true },
    style: {
      backgroundColor: 'transparent',
      title: { fill: '#ffffff' },
      axisTitle: { fill: '#ffffff' },
      axisLine: { stroke: '#ffffff' },
      grid: { stroke: '#333333' },
    },
  };

  return (
    <div style={{ width: '100%', height: '320px', position: 'relative' }}>
      <style>{hideMoreOptionsStyle}</style>
      <StackedBarChart data={data} options={options} />
    </div>
  );
};

export default StackedBar;
